import { render, staticRenderFns } from "./statueHistory.vue?vue&type=template&id=17a519ee&scoped=true"
import script from "./statueHistory.vue?vue&type=script&lang=ts"
export * from "./statueHistory.vue?vue&type=script&lang=ts"
import style0 from "./statueHistory.vue?vue&type=style&index=0&id=17a519ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a519ee",
  null
  
)

export default component.exports